import { DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBreakthroughFuelHistoryList extends Layout {
    searchpanelSearch: SearchPanel;
    sourceBreakthroughHistory: DataSource;
    tableBreakthrough: Table;
    textboxCarrierRefSearch: Textbox;
    textboxCustomerIdSearch: Textbox;
    textboxDownloadDate: Textbox;
    textboxLoadTenderRefSearch: Textbox;
    textboxOrderId: Textbox;
    textboxShipperNameSearch: Textbox;
}
